import type { FC } from "react";
import { AppImage } from "@components/NextImage";
import { cn } from "utils";
import { SIGN_IN_INTRO_ASSETS } from "./introSlidesConfig";

interface IntroBubbleTailProps {
  className?: string;
}

/** Figma bubble tail SVG (96293:46193 / 96293:46200). */
export const IntroBubbleTail: FC<IntroBubbleTailProps> = ({ className }) => (
  <AppImage
    src={SIGN_IN_INTRO_ASSETS.bubbleTail}
    alt=""
    width={7}
    height={12}
    className={cn("absolute -left-[7px] top-[18px]", className)}
    onError={(e) => {
      (e.target as HTMLImageElement).style.display = "none";
    }}
  />
);
